(function() {
    'use strict';

    function validateCallbackPhone(phone) {
        const phoneRegex = /^\+7 \([0-9]{3}\) [0-9]{3}-[0-9]{2}-[0-9]{2}$/;
        return phoneRegex.test(phone || '');
    }

    function collectCallbackFormFieldValues(formId, doc) {
        const nameInput = doc.getElementById('name-' + formId);
        const phoneInput = doc.getElementById('phone-' + formId);
        const timeInput = doc.getElementById('time-' + formId);
        const commentInput = doc.getElementById('comment-' + formId);
        const marketingConsentInput = doc.getElementById('marketing-consent-' + formId);
        const honeypotInput = doc.getElementById('website-' + formId);

        return {
            name: nameInput ? nameInput.value : '',
            phone: phoneInput ? phoneInput.value : '',
            preferredCallTime: timeInput ? timeInput.value : undefined,
            comment: commentInput ? commentInput.value : undefined,
            marketingConsent: !!(marketingConsentInput && marketingConsentInput.checked),
            honeypot: honeypotInput ? honeypotInput.value : ''
        };
    }

    function getCookie(name) {
        const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
        return match ? decodeURIComponent(match[1]) : '';
    }

    function collectAttributionSync() {
        const params = new URLSearchParams(window.location.search || '');
        return {
            yclid: params.get('yclid') || '',
            ymclid: params.get('ymclid') || '',
            ysclid: params.get('ysclid') || '',
            yrclid: params.get('yrclid') || '',
            utm_source: params.get('utm_source') || '',
            utm_medium: params.get('utm_medium') || '',
            utm_campaign: params.get('utm_campaign') || '',
            utm_content: params.get('utm_content') || '',
            utm_term: params.get('utm_term') || '',
            landing_page: window.location.origin + window.location.pathname + (window.location.search || ''),
            current_page: window.location.origin + window.location.pathname + (window.location.search || ''),
            referrer: document.referrer || '',
            ym_client_id: getCookie('_ym_uid') || ''
        };
    }

    function getFirstTouchAttribution() {
        const storageKey = 'xtron_first_touch_attribution_v1';
        try {
            const stored = sessionStorage.getItem(storageKey);
            if (stored) {
                const parsed = JSON.parse(stored);
                parsed.current_page = window.location.origin + window.location.pathname + (window.location.search || '');
                return parsed;
            }
        } catch (e) {
            // no-op
        }

        const data = collectAttributionSync();
        try {
            sessionStorage.setItem(storageKey, JSON.stringify(data));
        } catch (e) {
            // no-op
        }
        return data;
    }

    function buildCallbackRequestData(values, consentChecked, referrer, attribution) {
        return {
            name: values.name || '',
            phone: values.phone || '',
            email: undefined,
            preferredCallTime: values.preferredCallTime,
            comment: values.comment,
            pdConsent: !!consentChecked,
            marketingConsent: !!values.marketingConsent,
            consentScope: 'callback_form',
            pageUrl: referrer || '',
            honeypot: values.honeypot || '',
            attribution: {
                ymClientId: attribution.ym_client_id || '',
                yclid: attribution.yclid || '',
                ymclid: attribution.ymclid || '',
                ysclid: attribution.ysclid || '',
                yrclid: attribution.yrclid || '',
                utmSource: attribution.utm_source || '',
                utmMedium: attribution.utm_medium || '',
                utmCampaign: attribution.utm_campaign || '',
                utmContent: attribution.utm_content || '',
                utmTerm: attribution.utm_term || '',
                landingPage: attribution.landing_page || '',
                currentPage: attribution.current_page || '',
                referrer: attribution.referrer || '',
                formType: 'callback_form'
            }
        };
    }

    function initCallbackForms() {
        const callbackForms = document.querySelectorAll('.callback-form form');
        callbackForms.forEach((form) => {
            initCallbackForm(form);
        });
    }

    function initCallbackForm(form) {
        if (!form) {
            return;
        }
        if (form.dataset.callbackFormInitialized === 'true') {
            return;
        }
        form.dataset.callbackFormInitialized = 'true';

        const formContainer = form.closest('.callback-form');
        const formId = formContainer ? formContainer.id : 'callback-form';

        function showPhoneValidation(show, message = '') {
            const validator = document.getElementById('phone-validator-' + formId);
            const phoneInput = document.getElementById('phone-' + formId);

            if (show) {
                if (validator) {
                    validator.textContent = message;
                    validator.classList.add('show', 'invalid');
                    validator.classList.remove('valid');
                }
                if (phoneInput) phoneInput.classList.add('invalid');
            } else {
                if (validator) {
                    validator.textContent = '';
                    validator.classList.remove('show', 'invalid');
                    validator.classList.add('valid');
                }
                if (phoneInput) phoneInput.classList.remove('invalid');
            }
        }

        window.AjaxFormRuntime.bindSubmit(form, {
            formId: formId,
            collectValues: (fId, doc) => collectCallbackFormFieldValues(fId, doc),
            buildRequest: (vals, consentChecked, ctx) => {
                const attribution = getFirstTouchAttribution();
                return buildCallbackRequestData(vals, consentChecked, document.referrer, attribution);
            },
            getFetchArgs: (requestData, vals, form) => [
                '/api/lead/callback',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(requestData)
                }
            ],
            onBeforeSubmit: (form, formId) => {
                const phoneInput = document.getElementById('phone-' + formId);
                if (phoneInput && !validateCallbackPhone(phoneInput.value)) {
                    showPhoneValidation(true, 'Введите корректный номер телефона в формате +7 (XXX) XXX-XX-XX');
                    return false;
                }
                showPhoneValidation(false);
                return true;
            },
            onSuccess: (form, result) => {
                setTimeout(() => {
                    const modal = form.closest('.modal');
                    if (!modal || typeof bootstrap === 'undefined') {
                        return;
                    }

                    const bsModal = bootstrap.Modal.getInstance(modal);
                    if (bsModal) {
                        bsModal.hide();
                    }
                }, 2000);

                showPhoneValidation(false);
            }
        });
    }

    if (typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initCallbackForms);
        } else {
            initCallbackForms();
        }

        if (typeof window !== 'undefined') {
            window.initCallbackForms = initCallbackForms;
        }
    }
})();
